import React, { useState, useEffect } from "react";
import { Row } from "react-bootstrap";
import { motion } from 'framer-motion';
import TopProject from "../TopProject/TopProject";
import Spinner from "react-bootstrap/Spinner";
import "./TopProjects.css";
import Particle from "../../Shared/Particle/Particle";

const TopProjects = () => {
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);

  //fetch json data and setting it to a state
  useEffect(() => {
    fetch("./topProjectsData.json")
      .then((res) => res.json())
      .then((data) => {
        setProjects(data);
        setLoading(false);
      });
  }, []);

  return (
    <div
      className='container top-projects-container pt-5 pb-5'
      id='topProjects'
      style={{ maxWidth: '100vw' }}
    >
      <Particle />

      <motion.h1
        className='text-center mb-4 text-light'
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 3 }}
      >
        Top Personal Projects
      </motion.h1>
      <motion.h4
        className='text-center mb-4 text-light pb-5'
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 3 }}
      >
        Diverse Projects on Different Category
      </motion.h4>
      {
        <Row xs={1} md={1} className='gy-4'>
          {loading ? (
            <Spinner animation='grow' className='mx-auto' />
          ) : (
            projects?.map((project) => (
              <TopProject key={project._id} project={project}></TopProject>
            ))
          )}
        </Row>
      }
    </div>
  );
};

export default TopProjects;
